import { ChevronDown } from 'lucide-react';
import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cn } from '@/shared/lib/utils';

import { formControlBaseClassName } from '../shadcn/input';

export type NativeSelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * `<select>` HTML estilizado con el mismo lenguaje visual que `Input`.
 * Pensado para campos con un conjunto fijo y corto de opciones (≤5),
 * donde un combobox con búsqueda (`SearchableSelect`) sería innecesario.
 *
 * Para listas largas o que requieran filtrado, usar `SearchableSelect`.
 */
export const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div className={cn('relative w-full', className)}>
        <select
          ref={ref}
          className={cn(formControlBaseClassName, 'cursor-pointer appearance-none pr-10')}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          aria-hidden="true"
          className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
        />
      </div>
    );
  },
);
NativeSelect.displayName = 'NativeSelect';
